module.exports = __webpack_public_path__ + "public/img/ico-pw-rule-x.9df17ec6.svg";